<template>
  <div class="sketch_parent">
    <div class="wrapper">
      <div class="sketch_main">
        <div class="sketch_up_title">スケッチをアップロードしてください</div>
        <section>
          <p>
            ラフスケッチで結構ですので、描画頂き、携帯電話のカメラ機能を利用して撮影してください。<br>
            そのデータを下記までアップロード頂ければ、ミリスタイルスタッフが確認して、不明点等お電話で確認してご提案させていただきます。
          </p>
          <p>
            対応可能時間は以下の通りです。<br>
            月〜金曜 10:00〜18:00 (定休：土日祝)
          </p>
        </section>
        <section>
          <div class="sketch_user_info">
            <h3>お客様のID</h3>
            <div>{{userInfo.email}}</div>
          </div>
          <div class="sketch_user_info">
            <h3>お名前</h3>
            <div>{{userInfo.userLastName}} {{userInfo.userFirstName}}</div>
          </div>
        </section>
        <section>
          <h3 class="sketch_sub_title">①お問い合わせ可能な電話番号をご入力ください  (ご連絡可能な携帯電話など)</h3>
          <input type="text" v-model.trim="tel" @keypress="validateNumber" @input="tel=convertHalfNumber($event)" maxlength="11"/>
          <div v-if="errors.tel" class="error_text middle_text">{{errors.tel}}</div>
        </section>
        <section>
          <h3 class="sketch_sub_title">②アップロード内容（必須）</h3>
          <div>
            <p>ラフスケットの画像・施工場所の写真などをアップロードしてください。</p>
          </div>
          <div class="sketch_upload_form">
            <div>
              <div>{{viewUploadFilesName1}}</div>
            </div>
            <div @click="onClickUploadForm1">ファイルを選択</div>
            <input ref="fileInput1" type="file" @change="onUploadFileChange1" accept="image/*" />
            <div class="cross_btn3" @click="cancelImg1()" v-if="uploadFilesName1"></div>
            <div v-if="errors.fileSize1" class="error_text middle_text">{{errors.fileSize1}}</div>
          </div>
          <div class="sketch_upload_form">
            <div>
              <div>{{viewUploadFilesName2}}</div>
            </div>
            <div @click="onClickUploadForm2">ファイルを選択</div>
            <input ref="fileInput2" type="file" @change="onUploadFileChange2" accept="image/*" />
            <div class="cross_btn3" @click="cancelImg2()" v-if="uploadFilesName2"></div>
            <div v-if="errors.fileSize2" class="error_text middle_text">{{errors.fileSize2}}</div>
          </div>
          <div class="sketch_upload_form">
            <div>
              <div>{{viewUploadFilesName3}}</div>
            </div>
            <div @click="onClickUploadForm3">ファイルを選択</div>
            <input ref="fileInput3" type="file" @change="onUploadFileChange3" accept="image/*" />
            <div class="cross_btn3" @click="cancelImg3()" v-if="uploadFilesName3"></div>
            <div v-if="errors.fileSize3" class="error_text middle_text">{{errors.fileSize3}}</div>
          </div>
          <div class="sketch_upload_form">
            <div>
              <div>{{viewUploadFilesName4}}</div>
            </div>
            <div @click="onClickUploadForm4">ファイルを選択</div>
            <input ref="fileInput4" type="file" @change="onUploadFileChange4" accept="image/*" />
            <div class="cross_btn3" @click="cancelImg4()" v-if="uploadFilesName4"></div>
            <div v-if="errors.fileSize4" class="error_text middle_text">{{errors.fileSize4}}</div>
          </div>
          <div class="sketch_upload_form">
            <div>
              <div>{{viewUploadFilesName5}}</div>
            </div>
            <div @click="onClickUploadForm5">ファイルを選択</div>
            <input ref="fileInput5" type="file" @change="onUploadFileChange5" accept="image/*" />
            <div class="cross_btn3" @click="cancelImg5()" v-if="uploadFilesName5"></div>
            <div v-if="errors.fileSize5" class="error_text middle_text">{{errors.fileSize5}}</div>
          </div>
          <div v-if="errors.file" class="error_text middle_text">{{errors.file}}</div>
        </section>
        <section>
          <div>補足説明やご要望がある場合ご記入ください。</div>
          <textarea class="seketch_message" v-model="comment"/>
        </section>
        <section>
          <h3>③商品お届け先郵便番号の入力</h3>
          <div>配送料込みの見積り書を作成いたします。郵便番号をご入力ください。</div>
          <div>
            <div>郵便番号を入力する。（半角数値、ハイフン不要）</div>
            <input type="text" v-model.trim="deliveryForm.postcd" @keypress="validateNumber" @input="deliveryForm.postcd=convertHalfNumber($event)" oninput="if(value.length>7)value=value.slice(0,7)" ><br>
          </div>
          <div v-if="errors.postcd" class="error_text middle_text">{{errors.postcd}}</div>
        </section>
        <section id="input_construct">
          <h3>④ 組立設置サービスの選択</h3>
          <div class="input_btn_area">
            <div>
              <div class="button01" id="construction">
                <div class="button01" id="construction">
                  <input type="radio" name="construction_radio" id="construction_need" class="radio_need" value=1 v-model.number="workFlag" />
                  <label for="construction_need">あり</label>
                  <input type="radio" name="construction_radio" id="construction_no" class="radio_no" checked="" value=0 v-model.number="workFlag" />
                  <label for="construction_no">なし</label>
                </div>
              </div>
              <div>※組立設置をご希望の場合、担当者よりご連絡いたします。</div>
              <div class="customize_order" v-if="isConstruct">
                <div class="radio">
                  <input type="radio" id="const_someaddress" name="struct_address" :value="true" v-model="isStructSameAddress"/>
                  <label :for="'const_someaddress'" class="radio-label bold">納品先と同じ住所</label>
                </div>
                <div class="radio">
                  <input type="radio" id="const_differ" name="struct_address" :value="false" v-model="isStructSameAddress"/>
                  <label :for="'const_differ'" class="radio-label bold">納品先住所と異なる住所の郵便番号（半角数値、ハイフン不要）</label>
                </div>
                <div class="content_line">
                  <div v-bind:class="{disable_form: isStructSameAddress}">
                    <input type="text" v-model.trim="constructForm.postcd" @keypress="validateNumber" @input="constructForm.postcd=convertHalfNumber($event)" oninput="if(value.length>7)value=value.slice(0,7)" ><br>
                  </div>
                  <div v-if="errors.constructPostcd" class="error_text middle_text">{{errors.constructPostcd}}</div>
                </div>
                <!-- <div class="customize_sub" v-if="isResearch">
                  <div class="bold">受け取り搬入の有無をご入力ください。</div>
                  <div class="button01" id="construction_op">
                    <input type="radio" name="construct_op_radio" id="construct_op_need" class="radio_need" value=1 v-model.number="isCarryFlag" />
                    <label for="construct_op_need">あり</label>
                    <input type="radio" name="construct_op_radio" id="construct_op_no" class="radio_no" checked="" value=0 v-model.number="isCarryFlag" />
                    <label for="construct_op_no">なし</label>
                  </div>
                </div> -->
                <div class="customize_sub">
                  <ul>
                    <li>組立設置オプションには以下の費用が発生します。</li>
                    <li>組立技術料：組立作業費および副資材、簡易養生材など。</li>
                    <li>諸経費：交通費、燃料代など。</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="sketch_order_footer">
      <div class="sketch_order_next_btn" @click="confirm">次へ</div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import * as AppEc from '../utils/AppEc'
import * as FormUtil from '../../utils/FormUtil'
import * as Check from '../../utils/Check'
import {DC_URL, DC_STORAGE_KEY, STRUCT_CORP_ID_ST, STRUCT_CORP_ID_ED} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'

const FILE_SIZE_MAX = 5242880
const FILE_RESIZE_WIDTH = 1920

export default {
  components: {
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      tel: '',
      comment: '',
      workFlag: 0,
      isStructSameAddress: true,
      isCarryFlag: 0,
      deliveryForm: {
        postcd: '',
        state: '',
        city: '',
        street: ''
      },
      constructForm: {
        postcd: '',
        state: '',
        city: '',
        street: ''
      },
      uploadFiles1: {},
      uploadFiles2: {},
      uploadFiles3: {},
      uploadFiles4: {},
      uploadFiles5: {},
      userInfo: {},
      uploadFilesName1: '',
      uploadFilesName2: '',
      uploadFilesName3: '',
      uploadFilesName4: '',
      uploadFilesName5: '',
      viewUploadFilesName1: '',
      viewUploadFilesName2: '',
      viewUploadFilesName3: '',
      viewUploadFilesName4: '',
      viewUploadFilesName5: '',
      errors: {}
    }
  },
  computed: {
    isConstruct: function () {
      return this.workFlag === 1
    },
    isResearch: function () {
      return (this.userInfo && this.userInfo.corpId >= STRUCT_CORP_ID_ST && this.userInfo.corpId <= STRUCT_CORP_ID_ED)
    },
    isAnyFile: function () {
      if ((this.uploadFiles1 && Object.keys(this.uploadFiles1).length > 0) ||
        (this.uploadFiles2 && Object.keys(this.uploadFiles2).length > 0) ||
        (this.uploadFiles3 && Object.keys(this.uploadFiles3).length > 0) ||
        (this.uploadFiles4 && Object.keys(this.uploadFiles4).length > 0) ||
        (this.uploadFiles5 && Object.keys(this.uploadFiles5).length > 0)) {
        return true
      }
      return false
    }
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    route: function (name, params) {
      this.$router.push({
        name: name,
        query: params
      })
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    convertHalfNumber: function (event) {
      // 郵便番号や電話番号で最初に0がくる場合があるため別で用意
      let str = FormUtil.restHalfNumber(event.target.value)
      return str
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      str = FormUtil.deleteTopZero(str)
      return str
    },
    confirm: async function () {
      this.errors = {}
      this.validateRequire()
      this.validateFormat()
      this.validateSendFile()
      if (Object.keys(this.errors).length !== 0) {
        this.showErrorInput()
        return false
      }
      this.$refs.loadingModalRef.showModal(true)
      this.sendFlag = true
      await this.postcdCompleteDelivery()
      await this.postcdCompleteStruct()
      console.log('yubin end')
      // 確認画面に渡す入力データ
      let confirmForm = {
        tel: this.tel,
        uploadFilesName1: this.uploadFilesName1,
        uploadFilesName2: this.uploadFilesName2,
        uploadFilesName3: this.uploadFilesName3,
        uploadFilesName4: this.uploadFilesName4,
        uploadFilesName5: this.uploadFilesName5,
        viewUploadFilesName1: this.viewUploadFilesName1,
        viewUploadFilesName2: this.viewUploadFilesName2,
        viewUploadFilesName3: this.viewUploadFilesName3,
        viewUploadFilesName4: this.viewUploadFilesName4,
        viewUploadFilesName5: this.viewUploadFilesName5,
        comment: this.comment,
        deliveryPostcd: this.deliveryForm.postcd,
        isConstruct: this.isConstruct,
        constructPostcd: this.isStructSameAddress ? this.deliveryForm.postcd : this.constructForm.postcd,
        isCarryFlag: this.isCarryFlag === 1
      }
      App.setLocalStorage(DC_STORAGE_KEY.SKETCH_ORDER, confirmForm)

      let payload = new FormData()
      payload.append('tel', this.tel)
      if (this.uploadFiles1 && Object.keys(this.uploadFiles1).length > 0) {
        payload.append('sketchImg1', new Blob([this.uploadFiles1[0]], {type: 'image/png'}), this.uploadFiles1[0].name)
        payload.append('sketchImg1Name', this.uploadFilesName1)
        payload.append('viewSketchImg1Name', this.viewUploadFilesName1)
      }
      if (this.uploadFiles2 && Object.keys(this.uploadFiles2).length > 0) {
        payload.append('sketchImg2', new Blob([this.uploadFiles2[0]], {type: 'image/png'}), this.uploadFiles2[0].name)
        payload.append('sketchImg2Name', this.uploadFilesName2)
        payload.append('viewSketchImg2Name', this.viewUploadFilesName2)
      }
      if (this.uploadFiles3 && Object.keys(this.uploadFiles3).length > 0) {
        payload.append('sketchImg3', new Blob([this.uploadFiles3[0]], {type: 'image/png'}), this.uploadFiles3[0].name)
        payload.append('sketchImg3Name', this.uploadFilesName3)
        payload.append('viewSketchImg3Name', this.viewUploadFilesName3)
      }
      if (this.uploadFiles4 && Object.keys(this.uploadFiles4).length > 0) {
        payload.append('sketchImg4', new Blob([this.uploadFiles4[0]], {type: 'image/png'}), this.uploadFiles4[0].name)
        payload.append('sketchImg4Name', this.uploadFilesName4)
        payload.append('viewSketchImg4Name', this.viewUploadFilesName4)
      }
      if (this.uploadFiles5 && Object.keys(this.uploadFiles5).length > 0) {
        payload.append('sketchImg5', new Blob([this.uploadFiles5[0]], {type: 'image/png'}), this.uploadFiles5[0].name)
        payload.append('sketchImg5Name', this.uploadFilesName5)
        payload.append('viewSketchImg5Name', this.viewUploadFilesName5)
      }
      payload.append('comment', this.comment)
      payload.append('deliveryPostcd', this.deliveryForm.postcd)
      payload.append('deliveryState', this.deliveryForm.state)
      payload.append('deliveryCity', this.deliveryForm.city)
      payload.append('deliveryStreet', this.deliveryForm.street)
      payload.append('isConstruct', this.isConstruct)
      payload.append('constructPostcd', this.isStructSameAddress ? this.deliveryForm.postcd : this.constructForm.postcd)
      payload.append('constructState', this.isStructSameAddress ? this.deliveryForm.state : this.constructForm.state)
      payload.append('constructCity', this.isStructSameAddress ? this.deliveryForm.city : this.constructForm.city)
      payload.append('constructStreet', this.isStructSameAddress ? this.deliveryForm.street : this.constructForm.street)
      payload.append('isCarryFlag', this.isCarryFlag === 1)
      axios.post(DC_URL.SKETCH + '/upload', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.sendFlag = false
            this.$refs.loadingModalRef.showModal(false)
            this.$router.push({
              name: 'DcSketchUploadConfirm'
            })
          }
        }).catch(error => {
          Api.handleError(error)
          this.$refs.loadingModalRef.showModal(false)
        }).finally(() => {
        })
    },
    onUploadFileChange1: async function (event) {
      event.preventDefault()
      this.uploadFiles1 = undefined
      this.uploadFilesName1 = undefined
      this.viewUploadFilesName1 = undefined
      this.viewUploadFilesName1 = event.target.files[0].name
      if (event.target.files[0].name.toLowerCase().indexOf('.heic') > 0) {
        FormUtil.convertHeicListToJpeg(event.target.files[0], (result) => {
          this.uploadFiles1 = FormUtil.fileResize(result, FILE_RESIZE_WIDTH)
        })
        this.uploadFilesName1 = event.target.files[0].name.replace(/.heic/gi, '.jpeg')
      } else {
        this.uploadFiles1 = FormUtil.fileResize(event.target.files[0], FILE_RESIZE_WIDTH)
        this.uploadFilesName1 = event.target.files[0].name
      }
    },
    onClickUploadForm1: function () {
      this.$refs.fileInput1.click()
    },
    onUploadFileChange2: function (event) {
      event.preventDefault()
      this.uploadFiles2 = undefined
      this.uploadFilesName2 = undefined
      this.viewUploadFilesName2 = undefined
      this.viewUploadFilesName2 = event.target.files[0].name
      if (event.target.files[0].name.toLowerCase().indexOf('.heic') > 0) {
        FormUtil.convertHeicListToJpeg(event.target.files[0], (result) => {
          this.uploadFiles2 = FormUtil.fileResize(result, FILE_RESIZE_WIDTH)
        })
        this.uploadFilesName2 = event.target.files[0].name.replace(/.heic/gi, '.jpeg')
      } else {
        this.uploadFiles2 = FormUtil.fileResize(event.target.files[0], FILE_RESIZE_WIDTH)
        this.uploadFilesName2 = event.target.files[0].name
      }
    },
    onClickUploadForm2: function () {
      this.$refs.fileInput2.click()
    },
    onUploadFileChange3: function (event) {
      event.preventDefault()
      this.uploadFiles3 = undefined
      this.uploadFilesName3 = undefined
      this.viewUploadFilesName3 = undefined
      this.viewUploadFilesName3 = event.target.files[0].name
      if (event.target.files[0].name.toLowerCase().indexOf('.heic') > 0) {
        FormUtil.convertHeicListToJpeg(event.target.files[0], (result) => {
          this.uploadFiles3 = FormUtil.fileResize(result, FILE_RESIZE_WIDTH)
        })
        this.uploadFilesName3 = event.target.files[0].name.replace(/.heic/gi, '.jpeg')
      } else {
        this.uploadFiles3 = FormUtil.fileResize(event.target.files[0], FILE_RESIZE_WIDTH)
        this.uploadFilesName3 = event.target.files[0].name
      }
    },
    onClickUploadForm3: function () {
      this.$refs.fileInput3.click()
    },
    onUploadFileChange4: function (event) {
      event.preventDefault()
      this.uploadFiles4 = undefined
      this.uploadFilesName4 = undefined
      this.viewUploadFilesName4 = undefined
      this.viewUploadFilesName4 = event.target.files[0].name
      if (event.target.files[0].name.toLowerCase().indexOf('.heic') > 0) {
        FormUtil.convertHeicListToJpeg(event.target.files[0], (result) => {
          this.uploadFiles4 = FormUtil.fileResize(result, FILE_RESIZE_WIDTH)
        })
        this.uploadFilesName4 = event.target.files[0].name.replace(/.heic/gi, '.jpeg')
      } else {
        this.uploadFiles4 = FormUtil.fileResize(event.target.files[0], FILE_RESIZE_WIDTH)
        this.uploadFilesName4 = event.target.files[0].name
      }
    },
    onClickUploadForm4: function () {
      this.$refs.fileInput4.click()
    },
    onUploadFileChange5: function (event) {
      event.preventDefault()
      this.uploadFiles5 = undefined
      this.uploadFilesName5 = undefined
      this.viewUploadFilesName5 = undefined
      this.viewUploadFilesName5 = event.target.files[0].name
      if (event.target.files[0].name.toLowerCase().indexOf('.heic') > 0) {
        FormUtil.convertHeicListToJpeg(event.target.files[0], (result) => {
          this.uploadFiles5 = FormUtil.fileResize(result, FILE_RESIZE_WIDTH)
        })
        this.uploadFilesName5 = event.target.files[0].name.replace(/.heic/gi, '.jpeg')
      } else {
        this.uploadFiles5 = FormUtil.fileResize(event.target.files[0], FILE_RESIZE_WIDTH)
        this.uploadFilesName5 = event.target.files[0].name
      }
    },
    onClickUploadForm5: function () {
      this.$refs.fileInput5.click()
    },
    cancelImg1: function () {
      this.uploadFiles1 = undefined
      this.uploadFilesName1 = undefined
      this.viewUploadFilesName1 = undefined
    },
    cancelImg2: function () {
      this.uploadFiles2 = undefined
      this.uploadFilesName2 = undefined
      this.viewUploadFilesName2 = undefined
    },
    cancelImg3: function () {
      this.uploadFiles3 = undefined
      this.uploadFilesName3 = undefined
      this.viewUploadFilesName3 = undefined
    },
    cancelImg4: function () {
      this.uploadFiles4 = undefined
      this.uploadFilesName4 = undefined
      this.viewUploadFilesName4 = undefined
    },
    cancelImg5: function () {
      this.uploadFiles5 = undefined
      this.uploadFilesName5 = undefined
      this.viewUploadFilesName5 = undefined
    },
    validateRequire: function () {
      if (!this.tel) {
        this.errors['tel'] = '電話番号は必須項目です。'
      }
      if (!this.deliveryForm.postcd) {
        this.errors['postcd'] = '商品お届け先郵便番号は必須項目です。'
      }
      if (!this.isAnyFile) {
        this.errors['file'] = 'アップロードファイルは必須項目です。'
      }
      if (this.isConstruct && !this.isStructSameAddress) {
        if (!this.constructForm.postcd) {
          this.errors['constructPostcd'] = '組立設置サービスの郵便番号は必須項目です。'
        }
      }
      this.$forceUpdate()
    },
    validateFormat: function () {
      if (!Check.isTel(this.tel)) {
        this.errors['tel'] = '電話番号は半角数値かつ、10～11文字で入力してください。'
      }
      if (!Check.isPostCd(this.deliveryForm.postcd)) {
        this.errors['postcd'] = '商品お届け先郵便番号は半角数値で入力してください。'
      }
      if (this.isConstruct && !this.isStructSameAddress) {
        if (!Check.isPostCd(this.constructForm.postcd)) {
          this.errors['constructPostcd'] = '組立設置サービスの郵便番号は半角数値で入力してください。'
        }
      }
      this.$forceUpdate()
    },
    validateSendFile: function () {
      if (this.uploadFiles1 && Object.keys(this.uploadFiles1).length > 0) {
        this.validateFileSize(this.uploadFiles1[0], 1)
      }
      if (this.uploadFiles2 && Object.keys(this.uploadFiles2).length > 0) {
        this.validateFileSize(this.uploadFiles2[0], 2)
      }
      if (this.uploadFiles3 && Object.keys(this.uploadFiles3).length > 0) {
        this.validateFileSize(this.uploadFiles3[0], 3)
      }
      if (this.uploadFiles4 && Object.keys(this.uploadFiles4).length > 0) {
        this.validateFileSize(this.uploadFiles4[0], 4)
      }
      if (this.uploadFiles5 && Object.keys(this.uploadFiles5).length > 0) {
        this.validateFileSize(this.uploadFiles5[0], 5)
      }
      this.$forceUpdate()
    },
    validateFileSize: function (file, idx) {
      let byteSize = file.size
      if (byteSize > FILE_SIZE_MAX) {
        this.errors['fileSize' + idx] = '添付ファイルのサイズは5MB以下にしてください。'
      }
    },
    // 入力チェック
    postcdCompleteDelivery: async function () {
      console.log('do postcdCompleteDelivery1')
      await FormUtil.addressCompletion(this.deliveryForm.postcd, (address) => {
        this.$set(this.deliveryForm, 'state', address.state)
        this.$set(this.deliveryForm, 'city', address.city)
        this.$set(this.deliveryForm, 'street', address.street)
        // チェック処理
        console.log('do postcdCompleteDelivery2')
      })
    },
    postcdCompleteStruct: async function () {
      console.log('do postcdCompleteStruct1')
      if (!this.isConstruct) return
      let postcd = this.constructForm.postcd
      if (this.isStructSameAddress) {
        postcd = this.deliveryForm.postcd
      }
      await FormUtil.addressCompletion(postcd, (address) => {
        this.$set(this.constructForm, 'state', address.state)
        this.$set(this.constructForm, 'city', address.city)
        this.$set(this.constructForm, 'street', address.street)
        // チェック処理
        console.log('do postcdCompleteStruct2')
      })
    },
    showErrorInput: function () {
      AppEc.showModal({
        messages: ['入力内容を確認してください。'],
        onOk: this.onNew
      })
    }
  },
  mounted: function () {
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../css/dc-customize.scss" lang="scss" scoped></style>
<style src="../css/dc-sketch.scss" lang="scss" scoped></style>
<style src="../css/dc-common.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcSketchUpload.vue